import { render } from "./AdminAsset.vue?vue&type=template&id=cec4d2d6"
import script from "./AdminAsset.vue?vue&type=script&lang=js"
export * from "./AdminAsset.vue?vue&type=script&lang=js"

import "./AdminAsset.vue?vue&type=style&index=0&id=cec4d2d6&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__